export function getRandomChar(str: string) {
  return str.charAt(Math.floor(Math.random() * str.length));
}

export function shuffle(text: string) {
  const array: string[] = text.split("");
  let currentIndex: number = array.length,
    randomIndex: number;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array.join("");
}

export function generateP(options?: string[], length?: number): string {
  const groups: string[] = options ?? [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "abcdefghijklmnopqrstuvwxyz",
    "1234567890",
    "!@#$%^&()_+~`|}{[]:;?><,./-=",
  ];
  const lengthTemp: number = length || 8;
  let pass: string = groups.map(getRandomChar).join("");

  const str = groups.join("");

  for (let i = pass.length; i <= lengthTemp; i++) {
    pass += getRandomChar(str);
  }
  return shuffle(pass);
}

export function generateCId(): string {
  const arrStringRandom: string[] = ["ABCDEFGHIJKLMNOPQRSTUVWXYZ", "abcdefghijklmnopqrstuvwxyz", "1234567890"];
  return `${generateP(arrStringRandom, 8)}-${generateP(arrStringRandom, 4)}-${generateP(
    arrStringRandom,
    4
  )}-${generateP(arrStringRandom, 12)}`;
}
